import { render } from "./TenantManage.vue?vue&type=template&id=022dea1a&scoped=true"
import script from "./TenantManage.vue?vue&type=script&lang=js"
export * from "./TenantManage.vue?vue&type=script&lang=js"

import "./TenantManage.vue?vue&type=style&index=0&id=022dea1a&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022dea1a"]])

export default __exports__